import { jsx as _jsx } from "react/jsx-runtime";
import { Menu } from "@mui/material";
export const MyMealsNavBarMenu = ({ M, children }) => {
    return (_jsx(Menu, Object.assign({ id: "nav-bar-menu", anchorEl: M.anchorEl, open: M.open, onClose: () => M.handleClose(), MenuListProps: {
            "aria-labelledby": "nav-bar-button",
            sx: {
                paddingBottom: 0,
            },
        }, anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "center",
        } }, { children: children })));
};
